import request from '../../axios';

export const postLoanRequestFile = async (
  payload: IPostLoanRequestFilePayload,
) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const data = await request.post(
    '/api/v2/payment/loan-request-file',
    formData,
  );

  return data;
};
